/* eslint-disable import/no-cycle */
import { MAP_FORMAT } from './utils.mapFormats';
import {
  DEFAULT_INITIAL_DATA,
  FORM_NAMES,
  HEADER_CHECKBOXES_INITIAL_DATA,
  INITIAL_HEADERS_DATA
} from './constants';

export const getDefaultInitialData = (mapFormat) =>
  mapFormat === MAP_FORMAT.FIXED ? DEFAULT_INITIAL_DATA.FIXED : DEFAULT_INITIAL_DATA.DELIMITED;

export const createInitialFormData = ({ allowedMapFormat, initialData, mapFormat, modify }) => {
  const defaultInitialData = getDefaultInitialData(allowedMapFormat);

  if (!modify) {
    return defaultInitialData;
  }
  if (modify && mapFormat === allowedMapFormat) {
    return initialData;
  }
  return defaultInitialData;
};

export const storeFormReducer = (state, action) => {
  switch (action.type) {
    case 'fixed':
      return {
        ...state,
        fixed: action.formState
      };
    case 'delimited':
      return {
        ...state,
        delimited: action.formState
      };
    default: {
      const previousFormName =
        action.name === FORM_NAMES.DELIMITED ? FORM_NAMES.FIXED : FORM_NAMES.DELIMITED;
      const currentFormName = action.name;
      // resets form
      return {
        ...state,
        [previousFormName]: {
          ...state[previousFormName],
          mapName: undefined,
          ...INITIAL_HEADERS_DATA[previousFormName],
          ...HEADER_CHECKBOXES_INITIAL_DATA
        },
        [currentFormName]:
          action.name === FORM_NAMES.DELIMITED
            ? DEFAULT_INITIAL_DATA.DELIMITED
            : DEFAULT_INITIAL_DATA.FIXED
      };
    }
  }
};
